<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="bankAccountOperations"
    :maskFields="maskFields"
    @options-change="optionsChange"
    :serverItemsLength="totalItems"
    :loadOptions="options"
    :enableCustomFilters="true"
    :containTopToolbar="false"
    :typeOperators="typeOperators"
    :serverFields="serverFields"
    @filter-confirm-action="applyFilters"
    :initialFilters="initialFilters"
  >

    <template slot="new">
      <v-dialog
        :scrollable="true"
        persistent
        :fullscreen="true"
        v-if="$vuetify.breakpoint.smAndDown"
        v-model="dialogModel"
        @keydown.esc="dialogCancelAction"
      >
        <v-overlay :value="pageLoading">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <div v-if="loading">
          <v-skeleton-loader
            class="mx-auto d-none d-sm-block"
            type="article, actions"
          ></v-skeleton-loader>

          <v-skeleton-loader
            class="mx-auto d-sm-none"
            type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"
          ></v-skeleton-loader>
        </div>
        <v-card v-else>
          <v-card-title>
            <span class="h4">Nova Operação Bancária</span>
            <v-spacer></v-spacer>
              <v-btn
                text
                icon
                title="Cancelar"
                class="my-2"
                @click="dialogCancelAction"
              >
                <v-icon right dark>mdi-close-circle</v-icon>
              </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text id="dialogBody">

            <v-list
              :flat="false"
              :dense="false"
              class="mt-5"
            >
              <v-list-item-group
                :multiple="false"
                color="success"
              >
                
                <v-divider
                  key="divider-1"
                />
                <v-list-item
                  key="list-item-1"
                  @click="transferOpenAction"
                  :two-line="false"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-bank-transfer</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      <span class="title">Transferência</span>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-divider
                  key="divider-2"
                />
                <v-list-item
                  key="list-item-2"
                  @click="depositOpenAction"
                  :two-line="false"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-bank-transfer-in</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      <span class="title">Depósito</span>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-divider
                  key="divider-3"
                />
                <v-list-item
                  key="list-item-3"
                  @click="withdrawOpenAction"
                  :two-line="false"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-bank-transfer-out</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>
                      <span class="title">Saque</span>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                
                <v-divider
                  key="divider-last"
                />
                
              </v-list-item-group>
            </v-list>
            
            <WithdrawNew
              v-if="!$route.params.bankAccountId"
              @entry-created="entryCreated"
              :useModelInsteadOfButton="true"
              ref="withdrawNewRef"
            />

            <DepositNew
              v-if="!$route.params.bankAccountId"
              @entry-created="entryCreated"
              :useModelInsteadOfButton="true"
              ref="depositNewRef"
            />

            <TransferNew
              v-if="!$route.params.bankAccountId"
              @entry-created="entryCreated"
              :useModelInsteadOfButton="true"
              ref="transferNewRef"
            />

          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn class="my-2" @click="dialogCancelAction">
              Cancelar
            </v-btn>
          </v-card-actions>
        </v-card>
        <template v-slot:activator="{ on: dialog }" @open-dialog="dialogOpenAction">
          <v-tooltip top>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn
                color="primary"
                class="ma-1 d-none d-md-flex"
                v-on="{ ...tooltip, ...dialog }"
                @click="dialogOpenAction"
                :disabled="false">
                  Adicionar Operação Bancária
                <v-icon right dark>mdi-plus</v-icon>
              </v-btn>

              <v-btn
                class="d-md-none"
                color="primary"
                absolute
                right
                fab
                v-on="{ ...dialog }"
                @click="dialogOpenAction"
                :disabled="false"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>

            </template>
            <span>Criar Operação Bancária</span>
          </v-tooltip>
        </template>
      </v-dialog>

      <WithdrawNew
        v-if="!$route.params.bankAccountId && $vuetify.breakpoint.mdAndUp"
        @entry-created="entryCreated"
        modelNameSingular="Saque"
      />

      <DepositNew
        v-if="!$route.params.bankAccountId && $vuetify.breakpoint.mdAndUp"
        @entry-created="entryCreated"
        modelNameSingular="Depósito"
      />

      <TransferNew
        v-if="!$route.params.bankAccountId && $vuetify.breakpoint.mdAndUp"
        @entry-created="entryCreated"
        modelNameSingular="Transferência"
      />

      <v-btn
        v-if="$route.params.bankAccountId && $vuetify.breakpoint.mdAndUp"
        @click="redirectToBankAccountOperations()"
      >
        Ver todas as Operações Bancárias
      </v-btn>
    </template>

    <!-- <template slot="index_action1" v-if="!$route.params.bankAccountId">
      <WithdrawNew
        @entry-created="entryCreated"
      />
    </template>

    <template slot="index_action2" v-if="!$route.params.bankAccountId">
      <DepositNew
        @entry-created="entryCreated"
      />
    </template>

    <template slot="index_action3" v-if="!$route.params.bankAccountId">
      <TransferNew
        @entry-created="entryCreated"
      />
    </template> -->


    <!-- <template slot="new" v-if="$route.params.bankAccountId">
      <v-btn
        @click="redirectToBankAccountOperations()"
        >
          Ver todas as Operações Bancárias
        </v-btn>
    </template> -->

    <!-- <template slot="new" v-if="$can('create', $router.currentRoute.name)">
      <New
        @entry-created="entryCreated"
      />
    </template> -->

    <template slot="show" slot-scope="{ item }" v-if="$can('read', $router.currentRoute.name)">
      <DepositEdit v-if="item.typeValue == 'Deposit'"
        :entry="item"
        :readOnly="true"
        modelNameSingular="Depósito"
      />

      <WithdrawEdit v-if="item.typeValue == 'Withdraw'"
        :entry="item"
        :readOnly="true"
        modelNameSingular="Saque"
      />

      <TransferEdit v-if="item.typeValue == 'Transfer'"
        :entry="item"
        :readOnly="true"
        modelNameSingular="Transferência"
      />
    </template>

    <template slot="edit" slot-scope="{ item }" v-if="$can('update', $router.currentRoute.name)">
      <DepositEdit v-if="item.typeValue == 'Deposit'"
        :entry="item"
        @entry-updated="entryUpdated"
        modelNameSingular="Depósito"
        :isEdit="true"
      />

      <WithdrawEdit v-if="item.typeValue == 'Withdraw'"
        :entry="item"
        @entry-updated="entryUpdated"
        modelNameSingular="Saque"
        :isEdit="true"
      />

      <TransferEdit v-if="item.typeValue == 'Transfer'"
        :entry="item"
        @entry-updated="entryUpdated"
        modelNameSingular="Transferência"
        :isEdit="true"
      />
    </template>

    <template slot="delete" slot-scope="{ item }" v-if="$can('delete', $router.currentRoute.name)">
      <DepositDelete v-if="item.typeValue == 'Deposit'"
        :entry="item"
        @entry-destroyed="entryDeleted"
        modelNameSingular="Depósito"
      />

      <WithdrawDelete v-if="item.typeValue == 'Withdraw'"
        :entry="item"
        @entry-destroyed="entryDeleted"
        modelNameSingular="Saque"
      />

      <TransferDelete v-if="item.typeValue == 'Transfer'"
        :entry="item"
        @entry-destroyed="entryDeleted"
        modelNameSingular="Transferência"
      />
    </template>

    <!-- <template slot="tableFooter">
      <td><strong class="title">Saldo Total</strong></td>
      <td colspan="2"></td>
      <td class="text-xs-right title"><strong>{{ this.bankAccountTotalBalance | formatCurrency }}</strong></td>
    </template> -->

  </BaseIndex>
</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from "@shared_components/base_index.vue";
import DepositNew from "@models/bank_accounts/bank_account_operations/deposits/new.vue";
import DepositEdit from "@models/bank_accounts/bank_account_operations/deposits/edit.vue";
import DepositDelete from "@models/bank_accounts/bank_account_operations/deposits/delete.vue"; 
import WithdrawNew from "@models/bank_accounts/bank_account_operations/withdraws/new.vue";
import WithdrawEdit from "@models/bank_accounts/bank_account_operations/withdraws/edit.vue";
import WithdrawDelete from "@models/bank_accounts/bank_account_operations/withdraws/delete.vue";
import TransferNew from "@models/bank_accounts/bank_account_operations/transfers/new.vue";
import TransferEdit from "@models/bank_accounts/bank_account_operations/transfers/edit.vue";
import TransferDelete from "@models/bank_accounts/bank_account_operations/transfers/delete.vue";

export default {
  data() {
    return {
      bankAccountOperations: [],
      loading: true,
      pageLoading: false,
      dialogModel: false,
      withdrawNewDialog: false,
      depositNewDialog: false,
      transferNewDialog: false,
      totalItems: 0,
      initialFilters: [],
      tableHeaders: [
        //trocar id para code depois que vier a coluna
        { text: "Código", align: "left", sortable: true, value: "code" },
        { text: "Tipo", align: "left", sortable: true, value: "type" },
        { text: "Conta de Origem", align: "left", sortable: true, value: "sourceBankAccount.name" },
        { text: "Conta de Destino", align: "left", sortable: true, value: "targetBankAccount.name" },
        { text: "Data e Hora", align: "left", sortable: true, value: "date" },
        { text: "Valor", align: "left", sortable: true, value: "value" },
        { text: "Ações", align: "left", sortable: false, value: "action" }
      ],
      maskFields: [
        { field: 'value', mask: 'currency'},
        { field: 'date', mask: 'datetime' },
      ],
      bankAccountTotalBalance: null,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["date"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [],
      typeOperators: [],
      serverFields: [],
    };
  },
  props: {
    modelNameSingular: {
      type: String,
      default: "Operação Bancária"
    },
    modelNamePlural: {
      type: String,
      default: "Operações Bancárias"
    },
  },
  components: {
    BaseIndex: BaseIndex,
    DepositNew: DepositNew,
    DepositEdit: DepositEdit,
    DepositDelete: DepositDelete,
    WithdrawNew: WithdrawNew,
    WithdrawEdit: WithdrawEdit,
    WithdrawDelete: WithdrawDelete,
    TransferNew: TransferNew,
    TransferEdit: TransferEdit,
    TransferDelete: TransferDelete,
    // Edit: Edit,
    // Delete: Delete,
  },
  created() {
    // if (this.$route.params.bankAccountId) {
    //   let filter = { field: "sourceBankAccount.name", type: "list", operator: "in", fieldValues: [this.$route.params.bankAccountId], key: 0}; 
    //   this.initialFilters = [filter];
    // }

    // this.loadServerEntries();
  },
  mounted(){ 
  },
  methods: {
    withdrawOpenAction: function() {
      if (this.$refs.withdrawNewRef) {
        if (this.$refs.withdrawNewRef.$refs.baseNew) {
          this.$refs.withdrawNewRef.$refs.baseNew.openAction();
          this.dialogCancelAction();
        }
      }
    },
    transferOpenAction: function() {
      if (this.$refs.transferNewRef) {
        if (this.$refs.transferNewRef.$refs.baseNew) {
          this.$refs.transferNewRef.$refs.baseNew.openAction();
          this.dialogCancelAction();
        }
      }
    },
    depositOpenAction: function() {
      if (this.$refs.depositNewRef) {
        if (this.$refs.depositNewRef.$refs.baseNew) {
          this.$refs.depositNewRef.$refs.baseNew.openAction();
          this.dialogCancelAction();
        }
      }
    },
    dialogOpenAction: function() {
      // console.log("dialogOpenAction");
    },
    dialogCancelAction: function() {
      // console.log("dialogCancelAction");
      this.dialogModel = false;
    },
    applyFilters: function(filtersList) {
      this.filters = filtersList;
      this.options.page = 1;
      this.loadServerEntries();
    },
    loadServerEntries: function() {
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_BANK_ACCOUNT_OPERATIONS,
          fetchPolicy: "no-cache",
          variables: {
            input: {
              limit: this.options.itemsPerPage,
              offset: (this.options.page - 1) * this.options.itemsPerPage,
              sortBy: this.options.sortBy,
              sortDesc: this.options.sortDesc,
              fields: this.tableHeaders.map(val => val.value),
              filters: this.filters
            },
            bankAccountId: this.$route.params ? this.$route.params.bankAccountId : null
          },
          // variables: {
          //   bankAccountId: this.$route.params.bankAccountId
          // }
        })
        .then(response => {
          this.bankAccountOperations = response.data.accountContext.bankAccountOperationsIndex.bankAccountOperations;

          this.totalItems = response.data.accountContext.bankAccountOperationsIndex.count;
          this.typeOperators = response.data.accountContext.bankAccountOperationsIndex.typeOperators;
          this.serverFields = response.data.accountContext.bankAccountOperationsIndex.serverFields;

          // this.bankAccountTotalBalance = 0;
          // for (var bankAccount in this.bankAccounts) {
          //   this.bankAccountTotalBalance += this.bankAccounts[bankAccount].balance;
          // }
          // this.bankAccountTotalBalance = _.round(this.bankAccountTotalBalance, 2);
          // console.log("All bankAccountOperations", this.bankAccountOperations);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    entryUpdated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
    redirectToBankAccountOperations: function() {
      this.$router.push({ name: "BankAccountOperation"});
      this.loadServerEntries();
    },
    optionsChange: function(opts) {
      this.options = opts;
      this.loadServerEntries();
    }
  }
};

const LOAD_ALL_BANK_ACCOUNT_OPERATIONS = gql `
  query ($input: IndexInputObject!, $bankAccountId: ID) {
    accountContext {
      bankAccountOperationsIndex(input: $input, bankAccountId: $bankAccountId) {
        count
        bankAccountOperations {
          id
          code
          value
          date
          sourceBankAccount {
            id
            name
          }
          targetBankAccount {
            id
            name
          }
          type
          typeValue
          canBeDeleted
          undeletabilityReasons
        }
        typeOperators
        serverFields
      }
    }
  }
`;

</script>

<style scoped></style>
